export default __webpack_public_path__ + "static/media/7minfitness@2x.5d7da077.jpg";